// extracted by mini-css-extract-plugin
module.exports =  {"button":"zKNUAlVx9iHvekHcvyQ2","buttonWrapper":"Kv3hcED00hkRHjNl0PsY","copyButton":"zkIuH0D2rDT12iaVg8VQ","disabled":"oDcBDSCDdLjfOgcFhsan"};